import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { msalConfig } from './conf/msal/authConfig';

const root: ReactDOM.Root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const msalInstance: PublicClientApplication = new PublicClientApplication(msalConfig);
await (async () => {
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise(); // This will no longer throw this error since initialize completed before this was invoked
  // msalInstance.acquireTokenSilent(); // This will also no longer throw this error

})();

root.render(
  <React.StrictMode>
    <FluentProvider theme={webLightTheme}>
      <MsalProvider instance={msalInstance} >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider >
    </FluentProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
